import { endOfDay, startOfDay } from 'date-fns';

export const getDateWithStartOfDay = (date) => {
  if (date) return startOfDay(new Date(date));
  return startOfDay(new Date());
};

export const getDateWithEndOfDay = (date) => {
  if (date) return endOfDay(new Date(date));
  return endOfDay(new Date());
};

// This function is used to compare dates in ag-grid
// specifically for date with format: 'yyyy-MM-dd'
export const agGridDateComparator = (filterLocalDateAtMidnight, cellValue) => {
  // Convert cellValue (date from the data) to local date
  const cellDate = new Date(cellValue);
  // to remove any automatic timezone time added when initializing the date object
  cellDate.setHours(0, 0, 0, 0);

  // Check if the cell date is before, after, or the same as filter date
  if (cellDate < filterLocalDateAtMidnight) {
    return -1;
  }
  if (cellDate > filterLocalDateAtMidnight) {
    return 1;
  }
  return 0;
};
